import { FC, useMemo } from "react";
import { SettingIcon, HomeIcon } from "@components/icons";
import { Button } from "@components/button";
import "./app-menu.scss";
import { useNavigate } from "react-router-dom";
import { AppMenuContainer } from "./app-menu-container";
import { AppMenuSchemaType } from "@dialogs/app-add-edit-dialog/app-add-edit-form.schema";
import { darkenColor } from "@utils/color.util";
import { useOutsideClick } from "@hooks/use-outside-click";

export const AppMenuNavigate: FC<{
  menuData: AppMenuSchemaType[];
  appId: string;
  menuMap: {
    [x: string]: AppMenuSchemaType;
  };
  secondaryColor?: string;
  fontColor?: string;
  primaryColor?: string;
  showLeftMenu: boolean;
  isMobile: boolean;
  toggleLeftMenu?: (value?: boolean) => void;
}> = ({
  menuData,
  appId,
  menuMap,
  fontColor,
  primaryColor,
  showLeftMenu,
  toggleLeftMenu,
  isMobile,
}) => {
  const navigate = useNavigate();
  const menuRef = useOutsideClick<HTMLDivElement>(() => {
    if (isMobile) {
      toggleLeftMenu?.(false);
    }
  });

  const bgColor = useMemo(
    () => (primaryColor ? darkenColor(primaryColor) : "inherit"),
    [primaryColor],
  );

  return (
    <>
      {showLeftMenu && <div className="menu-mask" />}
      <div
        className={`app-menu-contents ${showLeftMenu ? "" : "absolute"}`}
        style={{ backgroundColor: primaryColor }}
        ref={menuRef}
      >
        <nav role="navigation">
          <AppMenuContainer
            menuData={menuData}
            appId={appId}
            menuMap={menuMap}
            fontColor={fontColor}
            bgColor={bgColor}
            toggleLeftMenu={isMobile ? toggleLeftMenu : undefined}
          />

          <ul className="bottom-menu" style={{ background: darkenColor(bgColor, 20) }}>
            <div className="menu-bottom-contents">
              <li>
                <Button
                  onClick={() => navigate("/apps")}
                  style={{ color: fontColor }}
                  variant="transparent"
                >
                  <HomeIcon size="11" color={fontColor} />
                  All Apps
                </Button>
              </li>
              <li style={{ marginTop: "1px" }}>
                <Button
                  onClick={() => navigate("/apps/settings")}
                  variant="transparent"
                  style={{ color: fontColor }}
                >
                  <SettingIcon size="11" color={fontColor} />
                  Settings
                </Button>
              </li>
            </div>
          </ul>
        </nav>
      </div>
    </>
  );
};
